"use client";

import React, { FC, memo } from "react";
import ReactMarkdown, { Options } from "react-markdown";
import remarkGfm from "remark-gfm";
import { mdxComponents, MDXWrapper, WrapperVariants } from "./components";

type PlainMarkdownProps = {
  content: string;
  className?: string;
} & WrapperVariants;

export const PlainMarkdown: FC<PlainMarkdownProps> = ({
  content,
  className,
  variant,
}) => {
  return (
    <MDXWrapper className={className} variant={variant}>
      <PlainMarkdownMemo
        skipHtml={false}
        remarkPlugins={[remarkGfm]}
        components={mdxComponents as Options["components"]}
      >
        {content}
      </PlainMarkdownMemo>
    </MDXWrapper>
  );
};

export const PlainMarkdownMemo: FC<Options> = memo(
  ReactMarkdown,
  (prevProps, nextProps) => prevProps.children === nextProps.children
);
